import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './footer/Footer';
import UnAuthNav from './navbar/UnAuthNav';
import UnAuthMobileNav from './navbar/UnAuthMobileNav';



const OutletUnAuthcomponent = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <UnAuthNav/>
      <UnAuthMobileNav/>
      <div style={{ flex: 1 }}>
        <Outlet />
      </div>
      <Footer isAuthenticated={false} isApproved={false} />
    </div>
  )
}

export default OutletUnAuthcomponent
